import { useMalpracticeRef } from '../account/vaultSelectors';
import { MalpracticeTabLayout } from './MalpracticeTabLayout';
import { MalpracticeRefContext } from './utils/provider';

export const MalpracticeWrapper = () => {
  const { malpracticeRef } = useMalpracticeRef();

  if (!malpracticeRef) {
    return null;
  }

  return (
    <MalpracticeRefContext.Provider value={malpracticeRef}>
      <MalpracticeTabLayout />
    </MalpracticeRefContext.Provider>
  );
};
